import React from 'react';
import { SUPPORTED_CURRENCIES } from '../services/api';

// Component for selecting the fiat currency
const CurrencySelector = ({ selectedCurrency, onCurrencyChange }) => {
  return (
    <div className="currency-selector">
      <h3>Step 1: Select Currency</h3>
      <div className="form-group">
        <label htmlFor="currency-select">Fiat Currency:</label>
        <select
          id="currency-select"
          value={selectedCurrency}
          onChange={(e) => onCurrencyChange(e.target.value)}
          className="form-control"
        >
          {SUPPORTED_CURRENCIES.map((currency) => (
            <option key={currency.code} value={currency.code}>
              {currency.name} ({currency.symbol})
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CurrencySelector;